
// enum per impostare l'ubicazione del server di database
// (necessario per pilotare la modalita' delle operazioni di backup/restore)
// --------------------------------------------------------------------------------------------------------
export enum DbLocationType { LAN = 0, AWSRDS = 1 }

// --------------------------------------------------------------------------------------------------------
export class SubscriptionDatabase {
  InstanceKey: string;
  SubscriptionKey: string;
  Name = '';
  Description = '';
  Dbserver = '';
  Dbname = '';
  Dbowner = '';
  Dbpassword = '';
  UseDms: false;
  Dmsdbserver = '';
  Dmsdbname = '';
  Dmsdbowner = '';
  Dmsdbpassword = '';
  Disabled: false;
  DatabaseCulture = '';
  IsUnicode: true;
  Provider = '';
  Test: false;
  UnderMaintenance: false;
  Confirmed: true;
  DeletionStatus: 0;
  Dbport: 0;
  DbLocation: DbLocationType.LAN;
  Storage = '';
  CreationDate: Date;

  // --------------------------------------------------------------------------------------------------------
  constructor() { }

  // --------------------------------------------------------------------------------------------------------
  assign(subDatabase?: SubscriptionDatabase) {
    this.InstanceKey = subDatabase.InstanceKey;
    this.SubscriptionKey = subDatabase.SubscriptionKey;
    this.Name = subDatabase.Name;
    this.Description = subDatabase.Description;
    this.Dbserver = subDatabase.Dbserver;
    this.Dbname = subDatabase.Dbname;
    this.Dbowner = subDatabase.Dbowner;
    this.Dbpassword = subDatabase.Dbpassword;
    this.UseDms = subDatabase.UseDms;
    this.Dmsdbserver = subDatabase.Dmsdbserver;
    this.Dmsdbname = subDatabase.Dmsdbname;
    this.Dmsdbowner = subDatabase.Dmsdbowner;
    this.Dmsdbpassword = subDatabase.Dmsdbpassword;
    this.Disabled = subDatabase.Disabled;
    this.DatabaseCulture = subDatabase.DatabaseCulture;
    this.IsUnicode = subDatabase.IsUnicode;
    this.Provider = subDatabase.Provider;
    this.Test = subDatabase.Test;
    this.UnderMaintenance = subDatabase.UnderMaintenance;
    this.Confirmed = subDatabase.Confirmed;
    this.DeletionStatus = subDatabase.DeletionStatus;
    this.Dbport = subDatabase.Dbport;
    this.DbLocation = subDatabase.DbLocation;
    this.Storage = subDatabase.Storage;
    this.CreationDate = subDatabase.CreationDate;
  }
}
